/**
 * Uncomment this only if you have js functionality for the component
 * 
 */

// Check if component is added to the page
if( jQuery('section.news').length ) {

    // Add tooltips to pagination
    if( jQuery('section.news .news-pagination').length ) {
        jQuery('section.news .news-pagination a.prev').attr('title', 'Previous page').addClass('tooltip');
        jQuery('section.news .news-pagination a.next').attr('title', 'Next page').addClass('tooltip');
        var lastTotal = 30;
        var newsPerPage = 30;
        jQuery( "section.news .news-pagination .page-numbers:not(.next, .prev)" ).each(function() {
            var tooltipText;
            if( lastTotal == 1 ) {
                tooltipText = '1 - '+newsPerPage;
            } else {
                tooltipText = lastTotal+' - '+( lastTotal + newsPerPage );
            }
            jQuery(this).attr('title', tooltipText).addClass('tooltip');
            lastTotal = lastTotal + newsPerPage;
        });
    }
    
}
